<div class="row">
  <div class="col-3">
    <h2>jbDnD - Example 3</h2>
  </div>
  <div class="col-9 text-right">
    <jb-btn jbText="jbDnD" (jbClick)="router.navigate(['/jbDnD'])"></jb-btn>
    <jb-btn jbText="Ex.1" (jbClick)="router.navigate(['/jbDnD/example1'])"></jb-btn>
    <jb-btn jbText="Ex.2" (jbClick)="router.navigate(['/jbDnD/example2'])"></jb-btn>
    <jb-btn jbText="Ex.3" (jbClick)="router.navigate(['/jbDnD/example3'])" jbDisabled="true"></jb-btn>
    <jb-btn jbText="Ex.4" (jbClick)="router.navigate(['/jbDnD/example4'])"></jb-btn>
    <jb-btn jbText="Ex.5" (jbClick)="router.navigate(['/jbDnD/example5'])"></jb-btn>
    <jb-btn jbText="Ex.6" (jbClick)="router.navigate(['/jbDnD/example6'])"></jb-btn>
  </div>
</div>
<hr/>
<h4>Multiple drop containers</h4>
<p>Drag and drop to different containers. Nested containers may behave differently depending on the option</p>


<div class="row">
  <div class="col-4">
    <div class="board">
      <h4 class="padB30">Draggable elements</h4>
      <div [jbDraggable]="obj1">{{obj1.name}}</div>
      <div [jbDraggable]="obj2">{{obj2.name}}</div>
      <div [jbDraggable]="obj3">{{obj3.name}}</div>
    </div>
  </div>

  <div class="col-4">
    <div class="c1" [jbDropContainer]="container1">
      <h5>Container 1</h5>
      <div class="c2" [jbDropContainer]="container3">
        <h5>Container 3</h5>
        <div class="c3" [jbDropContainer]="container4">
          <h5>Container 4</h5>
        </div>
      </div>
    </div>
  </div>

  <div class="col-4">
    <div [jbDropContainer]="container2">
      <h5>Container 2</h5>
    </div>
  </div>

  <div class="col-12">
    <jb-switch jbLabel="jbDnD.jbNestedContainers" jbLabelPos="left" class="nested-mode-switch"
               [(ngModel)]="isNestOp" (ngModelChange)="changeNestedOp($event)">
    </jb-switch>
    <div>activeContainer = <span class="demo-active-container-id">{{jbDnD.activeContainer?.id}}</span></div>
  </div>
</div>




<div class="row">
  <div class="col-12"><hr></div>

  <div class="col-5">
    <h5>View:</h5>
    <div class="code-box pad15">
      <pre>{{viewCode}}</pre>
    </div>
  </div>

  <div class="col-4">
    <h5>Ctrl:</h5>
    <div class="code-box pad15">
      <pre>{{ctrlCode}}</pre>
    </div>
  </div>

  <div class="col-3">
    <h5>Scss:</h5>
    <div class="code-box pad15">
      <pre>{{scssCode}}</pre>
    </div>
  </div>
</div>
